/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var modelGet = require('common/util/modelGet');
var FileUploadTableView = require('common/views/FileUploadTableView');

var tmplSecCorrespondenceModalView = require('../templates/SecCorrespondenceModalView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecCorrespondenceModalView,

  className: function() {
    var mode = this.options.mode || 'default';
    return 'sec-correspondence-modal-view sec-correspondence-modal-view-' + mode;
  },

  ui: {
    extFileUploadTableContainer: '.ext-file-upload-table-container',
    intFileUploadTableContainer: '.int-file-upload-table-container'
  },

  regions: {
    extFileUploadTableContainer: '@ui.extFileUploadTableContainer',
    intFileUploadTableContainer: '@ui.intFileUploadTableContainer'
  },

  events: {},

  templateHelpers: function() {
    // mode can be: 'org', 'inv-inq', or 'exam'
    return {
      mode: this.options.mode || null
    };
  },

  onBeforeShow: function() {
    var intDocuments = modelGet(this.model, 'intDocuments', []);
    var extDocuments = modelGet(this.model, 'extDocuments', []);

    this.intFileUploadTableView = new FileUploadTableView({
      collection: new Backbone.Collection(intDocuments),
      emptyText: 'No Internal Documents',
      isReadOnly: true
    });

    this.showChildView('intFileUploadTableContainer', this.intFileUploadTableView);

    this.extFileUploadTableView = new FileUploadTableView({
      collection: new Backbone.Collection(extDocuments),
      emptyText: 'No External Documents',
      isReadOnly: true
    });

    this.showChildView('extFileUploadTableContainer', this.extFileUploadTableView);
  }
});
